import { render, staticRenderFns } from "./Scale10ColorBlocksTeamStability.vue?vue&type=template&id=147e4a92&scoped=true"
import script from "./Scale10ColorBlocksTeamStability.vue?vue&type=script&lang=js"
export * from "./Scale10ColorBlocksTeamStability.vue?vue&type=script&lang=js"
import style0 from "./Scale10ColorBlocksTeamStability.vue?vue&type=style&index=0&id=147e4a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e4a92",
  null
  
)

export default component.exports